import * as styles from './FileMultiUpdateDialog.module.less';
import { WithOptional } from "@/common/typeHelpers";
import { getAllFiles, IEntrySelection, IFileRoot } from "../model/fileModel";
import { TromanDialog, TromanDialogBody, TromanDialogFooter, TromanDialogTitleHeader } from "../../TromanDialog";
import { useState } from "react";
import { ButtonVariants, TromanButton } from "../../Buttons";
import { formatFileCount, formatStatsSelection, getSelectionStats, ISelectionStats } from "../model/fileStats";
import { IUpdateMultipleFilesCmd } from '@/twapp/server/FileEndpoint';

export interface IPreparedMultiUpdate {
    selection: IEntrySelection;
    stats: ISelectionStats;
}

export function prepareMultiUpdate(selection: IEntrySelection): IPreparedMultiUpdate {
    return {
        selection,
        stats: getSelectionStats(selection),
    };
}

export interface IFileMultiUpdateDialogProps {
    files: IPreparedMultiUpdate;
    root: IFileRoot;
    busy: boolean;
    onClose: (cmd?: IUpdateMultipleFilesCmd) => void;
}

enum ChangeBoolean {
    None = "None", 
    True = "True",
    False = "False"
};

function getCommandValue(value: ChangeBoolean): boolean|null {
    if (value === ChangeBoolean.True) return true;
    if (value === ChangeBoolean.False) return false;
    return null;
}

function createCommand(root: IFileRoot, files: IPreparedMultiUpdate, showPolitiker: ChangeBoolean, showPublik: ChangeBoolean): IUpdateMultipleFilesCmd {
    return {
        OwnerId: root.ownerId,
        OwnerType: root.ownerType,
        FileIds: getAllFiles(files.selection).map(x => x.id),
        ShowPolitiker: getCommandValue(showPolitiker),
        ShowPublik: getCommandValue(showPublik),
    }
}

const FileMultiUpdateForm = ({root, files, busy, onClose}: IFileMultiUpdateDialogProps) => {
    const [showPolitiker, setShowPolitiker] = useState(ChangeBoolean.None);
    const [showPublik, setShowPublik] = useState(ChangeBoolean.None);
    
    return (
        <>
            <TromanDialogTitleHeader title="Ändra inställningar för publicering"/>
            <TromanDialogBody>
                <div>
                    <div>{formatStatsSelection(files.stats.immediate)}.</div>
                    <div>Totalt {formatFileCount(files.stats.total.fileCount)} kommer att uppdateras.</div>
                </div>

                <div className={styles.group}>
                    <div className={styles.header}>Troman Politiker</div>
                    <div className="radio">
                        <label>
                            <input type="radio" value={ChangeBoolean.None} checked={showPolitiker===ChangeBoolean.None} onChange={() => setShowPolitiker(ChangeBoolean.None)}/>
                            Ingen ändring
                        </label>
                    </div>
                    <div className="radio">
                        <label>
                            <input type="radio" value={ChangeBoolean.True} checked={showPolitiker===ChangeBoolean.True} onChange={() => setShowPolitiker(ChangeBoolean.True)}/>
                            Publicera
                        </label>
                    </div>
                    <div className="radio">
                        <label>
                            <input type="radio" value={ChangeBoolean.False} checked={showPolitiker===ChangeBoolean.False} onChange={() => setShowPolitiker(ChangeBoolean.False)}/>
                            Publicera inte
                        </label>
                    </div>
                </div>
                
                <div className={styles.group}>
                    <div className={styles.header}>Troman Publik</div>
                    <div className="radio">
                        <label>
                            <input type="radio" value={ChangeBoolean.None} checked={showPublik===ChangeBoolean.None} onChange={() => setShowPublik(ChangeBoolean.None)}/>
                            Ingen ändring
                        </label>
                    </div>
                    <div className="radio">
                        <label>
                            <input type="radio" value={ChangeBoolean.True} checked={showPublik===ChangeBoolean.True} onChange={() => setShowPublik(ChangeBoolean.True)}/>
                            Publicera
                        </label>
                    </div>
                    <div className="radio">
                        <label>
                            <input type="radio" value={ChangeBoolean.False} checked={showPublik===ChangeBoolean.False} onChange={() => setShowPublik(ChangeBoolean.False)}/>
                            Publicera inte
                        </label>
                    </div>
                </div>
            </TromanDialogBody>
            <TromanDialogFooter>
                <TromanButton variant={ButtonVariants.Success} text="Spara" disabled={busy} onClick={() => onClose(createCommand(root, files, showPolitiker, showPublik))}/>
                <TromanButton text="Avbryt" disabled={busy} onClick={() => onClose()}/>
            </TromanDialogFooter>
        </>
    )
};

export const FileMultiUpdateDialog = ({files, ...props}: WithOptional<IFileMultiUpdateDialogProps, "files">) => {
    return (
        <TromanDialog open={!!files}>
            {
                files && <FileMultiUpdateForm files={files} {...props}/>
            }
        </TromanDialog>
    )
};